import styled from "styled-components";

export const NavGroup = styled.ul`
  list-style: none;
  cursor: pointer;
  position: relative;

  a {
    color: #fff;
    display: flex;
    justify-content: center;
    padding: 1rem 0;
    text-decoration: none;

    &.active {
      color: #1ab394;
    }

    &:hover {
      background-color: rgba(0, 0, 0, 0.08);
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/MenuItemsFit/styles.js